var _style, _circle, _defs, _g, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatosUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.8 60",
    style: {
      enableBackground: "new 0 0 59.8 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DABEF8;}\r\n\t.st1{clip-path:url(#SVGID_00000181778629071896959730000001458261051255450012_);}\r\n\t.st2{fill:#9159CB;}\r\n\t.st3{fill:#633C85;}\r\n\t.st4{fill:none;}\r\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 29.9,
    cy: 30.1,
    r: 29.9
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 29.9,
    cy: 29.9,
    r: 29.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033351772478830425980000001207731742974976939_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000033351772478830425980000001207731742974976939_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.2,59.4H9.3c-0.9,0-1.7-0.7-1.7-1.6c0-0.1,0-0.1,0-0.2c0.9-12.1,11.1-21.7,23.5-21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,35.9c12.4,0,22.5,9.6,23.5,21.7c0,0.1,0,0.1,0,0.2c0,0.9-0.7,1.6-1.6,1.6H31.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.2,12.4c5.5,0,9.9,4.5,9.9,10c0,5.5-4.5,9.9-10,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.1,32.2c-5.5,0-9.9-4.5-9.9-9.9c0-5.5,4.5-9.9,10-9.9"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "31.2,12.1 54.8,12.1 54.8,59.8 7.4,59.8 7.4,12.1 31.2,12.1  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatosUsuario);
export default __webpack_public_path__ + "static/media/Datos_usuario.83b10bf734b0c6b9e8df8ba1cb6492c1.svg";
export { ForwardRef as ReactComponent };